/* eslint-disable */

const findLiaison = (zipCode, liaisonType) => {

    const liaisonDiv = document.querySelector('.medical-liaison');
    const liaisonNote = liaisonDiv.querySelector('.liaison__note');
    const liaisonDataDiv = liaisonDiv.querySelector('.liaison__data');
    const noResultsDiv = document.querySelector('.medical-liaison--no-results');

    fetch('/assets/files/zip_code.json')
    .then(response => response.json())
    .then(jsondata => {
        const liaisonName = jsondata.filter(x => {
            return x['ZIP'] === zipCode;  
        });

        //Validate that the zip code exisits in the list
        if(liaisonName.length > 0) {

            //Validate that there is a liaison assigned to that zip code
            if(liaisonName[0][liaisonType] != 'vacant' && liaisonName[0][liaisonType] != '') {
                fetch('/assets/files/liaison.json')
                .then(response => response.json())
                .then(liaisonData => {
                    const liaisonInfo = liaisonData.filter(x => {
                        return x['Name'] === liaisonName[0][liaisonType];
                    });

                    document.querySelector('form[data-loading="true"]').setAttribute('data-loading', 'false');

                    //Validate that liaison exists
                    if(liaisonInfo.length > 0) {
                        //Populate liaison info
                        liaisonDiv.setAttribute('data-type', liaisonInfo[0] ? liaisonType.toLowerCase() : '');
                        liaisonNote.querySelector('.liaison__note--type').innerText = liaisonInfo[0] ? liaisonType.toUpperCase() : '';
                        liaisonNote.querySelector('.liaison__note--zip').innerText = zipCode;
                        liaisonDataDiv.querySelector('.liaison__image img').src = liaisonInfo[0]["Photo"] ? '/assets/images/liaison/' + liaisonInfo[0]["Photo"] : '/assets/images/liaison/placeholder.jpeg';
                        liaisonDataDiv.querySelector('.liaison__name--full-name').innerText = liaisonInfo[0]['Name'] ? liaisonInfo[0]['Name'] : '';
                        liaisonDataDiv.querySelector('.liaison__name--crendentials').innerText = liaisonInfo[0]['Credentials'] ? liaisonInfo[0]['Credentials'] : '';
                        liaisonDataDiv.querySelector('.liaison__phone').href = liaisonInfo[0]['Phone Number'] ? 'tel:' + liaisonInfo[0]['Phone Number'] : '';
                        liaisonDataDiv.querySelector('.liaison__phone').innerText = liaisonInfo[0]['Phone Number'] ? liaisonInfo[0]['Phone Number'] : '';
                        liaisonDataDiv.querySelector('.liaison__email').href = liaisonInfo[0]['Email'] ? 'mailto:' + liaisonInfo[0]['Email'] : '';
                        liaisonDataDiv.querySelector('.liaison__email').innerText = liaisonInfo[0]['Email'] ? liaisonInfo[0]['Email'] : '';
                        liaisonDiv.querySelector('.liaison__bio').innerText = liaisonInfo[0]['Bio About'] ? liaisonInfo[0]['Bio About'] : '';
                        liaisonDiv.querySelector('.liaison__schools').innerText = "School(s) Attended: " + liaisonInfo[0]['Bio Schools Attended'];
                        if(!liaisonInfo[0]['Bio Schools Attended']) {
                            liaisonDiv.querySelector('.liaison__schools').hidden = true;
                        }
                        else {
                            liaisonDiv.querySelector('.liaison__schools').hidden = false;
                        }

                        liaisonDiv.querySelector('.liaison__states').innerText = "State(s) Covered: " + liaisonInfo[0]['Bio States Covered'].join(", ");
                        if(liaisonInfo[0]['Bio States Covered'].length === 0) {
                            liaisonDiv.querySelector('.liaison__states').hidden = true;
                        }
                        else {
                            liaisonDiv.querySelector('.liaison__states').hidden = false;
                        }

                        liaisonDiv.hidden = false;
                        liaisonDiv.focus();
                    }
                    else {
                        noResultsDiv.hidden = false;
                        noResultsDiv.focus();
                    }
                });
            }
            else {
                document.querySelector('form[data-loading="true"]').setAttribute('data-loading', 'false');
                noResultsDiv.hidden = false;
                noResultsDiv.focus();
            }
        }
        else {
            document.querySelector('form[data-loading="true"]').setAttribute('data-loading', 'false');
            noResultsDiv.hidden = false;
            noResultsDiv.focus();
        }
    });
};

export {
    findLiaison,
}
